import { render, staticRenderFns } from "./dashboard-selector.vue?vue&type=template&id=4faa0f36&scoped=true&"
import script from "./dashboard-selector.vue?vue&type=script&lang=js&"
export * from "./dashboard-selector.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-selector.vue?vue&type=style&index=0&id=4faa0f36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa0f36",
  null
  
)

export default component.exports